/**
 * CMS Store Initialization Plugin
 * Ensures Pinia stores are properly initialized for CMS layer
 */

export default defineNuxtPlugin({
  name: 'cms-store-init',
  dependsOn: ['pinia'],
  async setup(nuxtApp) {
    // Only run on client
    if (process.server) return

    // Wait for app to be fully mounted and Pinia to be ready
    nuxtApp.hooks.hook('app:mounted', async () => {
      try {
        // Wait for Pinia to be fully initialized
        await nextTick()
        
        // Pre-initialize critical stores for CMS
        const { useDataStore } = await import('~/layers/adme-blob-cms/store/dataStore')
        const { usePageBuilderStore } = await import('~/layers/adme-blob-cms/store/pageBuilderStore')
        
        // Initialize stores to ensure they're available
        const dataStore = useDataStore()
        const pageBuilderStore = usePageBuilderStore()
        
        console.log('[CMS Store Init] CMS stores initialized successfully')
        
        // Make stores globally available for debugging
        if (process.dev) {
          ;(globalThis as any).__CMS_STORES__ = {
            dataStore,
            pageBuilderStore
          }
        }
        
      } catch (error) {
        console.error('[CMS Store Init] Error initializing CMS stores:', error)
      }
    })
  }
})
